import * as React from "react";
import styled from "styled-components";
import { getColor, getDisabledColor } from "../../../../../ui/_themes/helpers";
import { Icon } from "../../../../../ui/IconSVG";
import { Wrapper } from "../../../../../ui/SettingButton/components/Wrapper";
import { E2EIdentifier } from "../../../../e2e/E2EIdentifier";

const ArrowIcon = props => <Icon type="keyboardarrow" {...props} />;

const Indicator = styled(ArrowIcon)`
  margin-top: ${({ rotate }) => (rotate === 0 ? "0.2em" : "0")};
  width: 1.2em;
  height: 1.2em;
  transition: transform 0.5s;
  transform: ${({ rotate }) => `rotate(${rotate}deg)`};
`;

export const TitleText = styled.div`
  font-size: 0.7em;
  font-weight: 700;
  letter-spacing: 0.03em;
`;

export const IndicatorArrow = props => <Indicator {...props} />;

export const StyledWrapper = styled(Wrapper)<{ expand; disabled }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 9.2em;
  height: 2.2em;
  margin: 0 auto;
  background: ${getDisabledColor(
    "settingButtonBackground",
    "settingButton.background"
  )};
  border-color: ${({ expand }) =>
    expand
      ? getDisabledColor("settingButtonBorder", "settingButton.border")
      : getColor("settingButton")};
  color: ${({ expand, disabled }) =>
    expand
      ? getDisabledColor("settingButton", "settingButton")
      : disabled
      ? getDisabledColor("settingButton")
      : getColor("settingButton")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
  cursor: ${({ expand, disabled }) =>
    disabled ? "auto" : expand ? "auto" : "pointer"};
`;

export const Title = ({ apiName, title, onClick, expand, disabled }) => {
  const up = -180;
  const down = 0;

  return (
    <StyledWrapper
      data-e2e-id={E2EIdentifier.AUTOPLAY_ADVANCED_SETTING_BUTTON}
      apiName={apiName}
      expand={expand}
      disabled={disabled}
      onClick={onClick}
    >
      <TitleText>{title}</TitleText>
      <IndicatorArrow rotate={expand ? up : down} />
    </StyledWrapper>
  );
};
